import { SearchPromotionItem } from '../../SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';
import { ChevronIcon } from './OverflowSpecialtyOption.styles';
import { SpecialtyContainer } from './SpecialtyOption.styles';

interface Props {
  text: string;
  overflowSpecialties: SearchPromotionItem[];
  onClick: () => void;
  menuIsOpen: boolean;
  className?: string;
}

export const OverflowSpecialtyOption = ({ text, onClick, menuIsOpen, className }: Props) => (
  <SpecialtyContainer onClick={onClick} className={className}>
    {text}
    <ChevronIcon open={menuIsOpen} className={className} />
  </SpecialtyContainer>
);
